export const getUsers = () => {
  try {
    const storage = localStorage;
    const userData = storage.getItem("user");

    if (!userData) return null;

    return JSON.parse(userData);
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};

export const getAccessTokenAsync = () => {
  return new Promise((resolve, reject) => {
    try {
      const loginType = localStorage.getItem("loginType");
      const access_token =
        loginType === "false"
          ? JSON.parse(sessionStorage.getItem("user"))?.access_token
          : JSON.parse(localStorage.getItem("user"))?.access_token;

      if (!access_token) {
        console.warn("No access token found");
        resolve(null);
        return;
      }

      setTimeout(() => {
        resolve(access_token);
      }, 100);
    } catch (error) {
      reject(error);
    }
  });
};

export const isDiscordIsVerified = () => {
  try {
    const storage = localStorage;
    const userData = JSON.parse(storage.getItem("user"));
    if (!userData) return null;
    if (userData?.is_discord_verified) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error getting user data:", error);
    return null;
  }
};
